export enum ClientEnum {
  SemInformacao = -1,
  Hyundai = 1,
  Volkswagen = 2,
  Toyota = 3,
  Fiat = 4,
  Dealerbook = 5,
  Jeep = 6,
  GM = 7,
  Chrysler = 8,
  Porsche = 9,
  Ford = 10,
  Peugeot = 11,
  Citroen = 12,
  Neocom_13 = 13,
  Lexus = 15,
  FusaoHyundai = 16,
  Renault = 17,
  Audi = 18,
  NeocomPremium = 19,
  Mitsubishi = 20,
  Honda = 21,
  Mercedes = 23,
  Triumph = 24,
  'Caoa Chery' = 25,
  Bmw = 26,
  Ram = 27,
  Yamaha = 28,
  'Great Wall' = 30,
  Isuzu = 31,
  Mini = 32,
  LandRover = 33,
  DPaschoal = 34,
  ACDelco = 36,
  Gac = 37,
  Mg = 38,
  Byd = 39,
  Volvo = 40,
  'Omoda | Jaecoo' = 42,
  'Royal Enfield' = 43,
  Nissan = 44,
  'Honda Moto Peças' = 45,
  Jetour = 46
}
